import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  role: "alert",
  "aria-live": "assertive",
  "aria-atomic": "true",
  class: "toast toast-error position-fixed",
  id: "error-toast",
  "data-bs-autohide": "false"
}
const _hoisted_2 = { class: "toast-header border-0 rounded bg-danger text-white flex-1" }
const _hoisted_3 = { class: "me-auto ms-2" }

import { onBeforeUnmount, onMounted, ref } from "vue";
import { Toast } from "bootstrap";
import { EventBus, EventBusNames } from "@/utils/EventBus";


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorAlertComponent',
  setup(__props) {

const msg = ref("");
const toast = () => new Toast(document.getElementById("error-toast")!);

const hideToast = () => {
  toast().hide();
};
function handleToast(data: { msg?: string }) {
  msg.value = data.msg ?? "";
  toast().show();
  setTimeout(hideToast, 6000);
}

onMounted(() => {
  EventBus.$on(EventBusNames.SHOW_ERROR_TOAST, handleToast);
});
onBeforeUnmount(() => {
  EventBus.$off(EventBusNames.SHOW_ERROR_TOAST, handleToast);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "fas fa-exclamation-circle" }, null, -1)),
      _createElementVNode("strong", _hoisted_3, _toDisplayString(msg.value), 1),
      _cache[1] || (_cache[1] = _createElementVNode("button", {
        type: "button",
        class: "btn-close text-white",
        "data-bs-dismiss": "toast",
        "aria-label": "Close"
      }, null, -1))
    ])
  ]))
}
}

})